import { service } from '../../../service';
import moment, { min } from 'moment';

const state = {
  loading: false,
  items: {},
  httpResponse: null,
};

const actions = {
  async create({ dispatch, commit, rootState }, payload) {
    payload.company = rootState.account.company._id;
    payload.location = rootState.account.location._id;

    var result = await service.post(`/availability`, payload);

    if (result) {
      commit('setResponse', result);
      dispatch('alert/success', result.message, { root: true });
    }

    return;
  },

  async fetch({ dispatch, commit, rootState }, data) {
    var url = `/availability/company/${rootState.account.company._id}/location/${rootState.account.location._id}`;
    url = url.params(data);

    var result = await service.get(url);
    if (result) {
      commit('setItem', result);
    }

    return;
  },

  async updateById({ dispatch, commit, rootState }, payload) {
    let id = payload._id;
    delete payload._id;

    var result = await service.patch(`/availability/${id}`, payload);

    if (result) {
      commit('setResponse', result);
      dispatch('alert/success', result.message, { root: true });
    }

    return;
  },

  async deleteById({ dispatch, commit, rootState }, id) {
    var result = await service.delete(`/availability/${id}`);

    if (result) {
      commit('setResponse', result);
      dispatch('alert/success', result.message, { root: true });
    }

    return;
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setResponse(state, result) {
    state.httpResponse = result;
    state.loading = false;
  },
  setItem(state, result) {
    let newObject = {};

    // update response format for more easier accessibility on front-end
    result.availability.docs.forEach((data, index) => {
      if (!(data.candidate in newObject)) {
        newObject[data.candidate] = {};
        newObject[data.candidate][
          `${moment(data.start_date).format('YYYY-MM-DD')}`
        ] = data;
      } else {
        newObject[data.candidate][
          `${moment(data.start_date).format('YYYY-MM-DD')}`
        ] = data;
      }
    });

    // sample output format
    // {
    //     "5fc0fb4d5ad58000f615661c": {  <--- candidate_id
    //       "2021-01-10": { <----- date
    //         "type": "",
    //         "reasons": "",
    //         "_id": "5ff20ab1defde068d0f99892",
    //         "candidate": "5fc0fb4d5ad58000f615661c",
    //         "start_date": "2021-01-09T16:00:00.000Z",
    //         "end_date": "2021-01-09T16:00:00.000Z",
    //         "availability": true,
    //         "start_time": "00:00",
    //         "end_time": "00:00",
    //         "company": "5e14943a26db9943432220ed",
    //         "location": "5e14943a26db9943432220ee",
    //         "createdAt": "2021-01-03T18:19:29.382Z",
    //         "updatedAt": "2021-01-03T18:19:29.382Z",
    //         "__v": 0
    //       },

    state.items = newObject;
    state.loading = false;
  },
};

export const availability = {
  namespaced: true,
  state,
  actions,
  mutations,
};
